import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhxTokenizeInputComponent } from './phx-tokenize-input.component';
import { PhxTagModule } from '../tag/phx-tag.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule, PhxTagModule],
  declarations: [PhxTokenizeInputComponent],
  exports: [PhxTokenizeInputComponent],
})
export class PhxTokenizeInputModule {}